<template>
 <main class="dn-margin-1">
    <img src="https://dn-resource-a.obs.cn-south-1.myhuaweicloud.com/%E7%83%98%E5%B9%B2%E6%9C%BA/%E6%89%BF%E9%87%8D%E5%BA%95%E6%9D%BF%281%29.jpg" class="card-img-top" >
  </main>
</template>

<script>
import { readUserAgent } from '../assets/js/dn-common.js'
export default {
  name: 'Main',
  data () {
    return {
    }
  }
}
</script>
<style scoped>

.dn-margin-1 {
  vertical-align: middle;
  height: 100%;
  margin-top: 0px;
  overflow: auto;
}

</style>



// WEBPACK FOOTER //
// src/components/czdb.vue